import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-status-roteiro',
    templateUrl: './status-roteiro.component.html',
    styleUrls: ['./status-roteiro.component.css']
})
export class StatusRoteiroComponent {
  @Input() mensagem; 
  @Input() color;
  @Input() caminho;
}
